import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/store';
import { PersistGate } from "redux-persist/integration/react";

// window.addEventListener("unhandledrejection", (event) => {
//   console.error("Unhandled promise rejection:", event.reason);
// });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
    {/* <App /> */}
  </React.StrictMode>
);
